import type { MascotState } from "../contract"
import type { BeamState } from "./Beam"

/**
 * The backend still names its live states after the old mascot (contract.ts
 * DEFAULT_MASCOT). The beam has fewer moods: listening while it waits on the
 * person, working while it reads and searches, done when the answer lands,
 * and still otherwise.
 */
export function beamStateFor(mascot: MascotState | null | undefined): BeamState {
  switch (mascot) {
    case "listening":
    case "asking":
    case "peek":
      return "listening"
    case "searching":
    case "section":
      return "working"
    case "done":
      return "done"
    case "error":
      return "static"
    default:
      return "idle"
  }
}
